import React from 'react';
import { mdiChevronRight } from '@mdi/js';
import { Link, Icon } from '@upgrade/react-components';
import { StyledContainer, StyledLink, StyledSegment } from './styles';
import { StyledLineHeader } from '../styles';

const Breadcrumb = ({ currentPage, paths, center, color = 'content', linkColor = 'actionable' }) => {
  return (
    <StyledContainer center={center}>
      {paths?.map(path => (
        <StyledSegment key={path.url}>
          <Link anchorComponent={StyledLink} key={path.url} to={path.url} href={path.url}>
            <StyledLineHeader data-color={linkColor}>{path.label}</StyledLineHeader>
          </Link>
          <Icon color={color} icon={mdiChevronRight} size="small" aria-hidden />
        </StyledSegment>
      ))}
      {currentPage && (
        <StyledSegment>
          <Link href="" anchorComponent={StyledLink} aria-current="page">
            <StyledLineHeader data-color={color}>{currentPage}</StyledLineHeader>
          </Link>
        </StyledSegment>
      )}
    </StyledContainer>
  );
};

export default Breadcrumb;
